<template>
    <component
        :is="is"
        :data-component="$options.name"
        class="relative overflow-hidden w-[281px] screen-m:w-[348px] screen-l:w-[289px] screen-xxl:w-[346px] shadow hover:shadow-hover rounded-10 bg-white border border-solid border-wildsand"
    >
        <a
            class="ms-recommender-item__clickArea"
            target="_blank"
            rel="noopener"
            aria-label="Go to estate"
            :href="item.detailUrl"
            @click="onClickItem"
        />
        <img
            v-if="item.smallImageUrl"
            class="ms-recommender-item__gridSmallImages"
            :src="item.smallImageUrl"
            :alt="item.title"
        />
        <div
            v-else
            class="flex items-center justify-center bg-color-brand-beige-50 ms-recommender-item__gridSmallImages"
        >
            <ms-fall-back />
        </div>
        <cs-tag
            v-if="item.imageCount"
            class="right-0 absolute mx-8 -mt-32"
            :type="'media'"
        >
            <template #icon> <ms-image /> </template>{{ item.imageCount }} Bilder</cs-tag
        >
        <div class="flex-row p-16">
            <div class="mb-4 flex">
                <cs-tag
                    v-if="item.newestEstate"
                    class="mr-8 text-white"
                    :text="'Neu'"
                    :colorClass="'bg-color-alert-positive'"
                    >Neu</cs-tag
                >
                <ms-headline
                    :type="'h4'"
                    class="truncate"
                    >{{ item.title }}</ms-headline
                >
            </div>
            <p class="mb-16 truncate">{{ item.address }}</p>
            <div class="flex mb-16">
                <div
                    v-if="item.livingArea"
                    class="flex mr-24"
                >
                    <ms-floor-plan class="w-24 h-24 mr-8" />
                    <p class="content-center">{{ item.livingArea }} m²</p>
                </div>
                <div
                    v-if="item.rooms"
                    class="flex mr-24"
                >
                    <ms-door class="w-24 h-24 mr-8" />
                    <p class="content-center">{{ item.rooms }} Zimmer</p>
                </div>
                <div
                    v-if="item.landArea && showLandArea()"
                    class="flex mr-24"
                >
                    <ms-surface class="w-24 h-24 mr-8" />
                    <p class="content-center">{{ item.landArea }} m²</p>
                </div>
            </div>
            <div class="h-1 mb-16 w-auto bg-color-neutral-grey-10" />
            <div class="text-end">
                <p class="text-text-l font-bold">{{ item.price }}</p>
                <p class="text-caption text-color-neutral-grey-60">{{ item.priceAppendix }}</p>
            </div>
        </div>
        <section class="absolute top-0 right-0 flex flex-col items-end justify-between z-content-linkarea">
            <ms-like-button
                :componentId="ComponentName.RECOMMENDER"
                :decoratedEstate="item"
                :isExposeeOnline="isExposeeOnline"
                :partOfRecommender="true"
                :isVerticalDesign="true"
            />
        </section>
    </component>
</template>
<script lang="ts" src="./MsRecommenderItem.ts" />
<style lang="scss" src="./MsRecommenderItem.scss" />
